import React from 'react';
import X from '@uber/base-icons/x';
import { styled } from 'baseui';
import { Button, KIND, SHAPE, SIZE } from 'baseui/button';
import { HeadingXSmall } from 'baseui/typography';
type PropsT = {
  title: string;
  onClose: () => void;
};
const Header = styled('div', ({
  $theme
}) => ({
  padding: `${$theme.sizing.scale500} ${$theme.sizing.scale500} ${$theme.sizing.scale200} ${$theme.sizing.scale500}`,
  borderBottom: $theme.borders.border300.borderColor ? `1px solid ${$theme.borders.border300.borderColor}` : `1px solid ${$theme.colors.borderOpaque}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'sticky',
  top: 0,
  backgroundColor: $theme.colors.backgroundPrimary,
  zIndex: 1
}));
const CloseButton = styled(Button, ({
  $theme
}) => ({
  minWidth: 'auto',
  padding: `${$theme.sizing.scale100} ${$theme.sizing.scale200}`
}));
export const ReviewSuggestionsSidePanelHeader = ({
  title,
  onClose
}: PropsT) => {
  return <Header>
      <HeadingXSmall margin={0}>{title}</HeadingXSmall>
      <CloseButton kind={KIND.tertiary} size={SIZE.compact} shape={SHAPE.circle} onClick={onClose} aria-label="Close review suggestions panel">
        <X />
      </CloseButton>
    </Header>;
};